import type { FaireProductEntity } from "../../entity_types/product";

export const p_6fo5jd08gd: FaireProductEntity = {
  token: "p_6fo5jd08gd",
  type: "product",
  name: "Swedish Dishcloths: 3-pack | Made in Sweden",
  brandToken: "b_69jqux09qb",
  brandName: "Me Mother Earth",
  imageUrl:
    "https://cdn.faire.com/fastly/34a490a0a3ecf6f19947df388cbb07f535cf5f4a457d601e615ef116fb37b188.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/297b59a173b326db88066542243488dbeaf51efd666887b26f76e74fe3912e43.jpeg",
    "https://cdn.faire.com/fastly/474a178f641ed24d9add3934f85320fccd17c5346093b5c69351d5602ab3e40f.jpeg",
    "https://cdn.faire.com/fastly/aeeb660fc9dbc2f658f296f8fd3ade5c080a7d7495e3d978876c189ded81b98f.jpeg",
    "https://cdn.faire.com/fastly/d4a5849937b0248d5583927b102b6930a4cce506100134f14607ba2861f56cd0.jpeg",
    "https://cdn.faire.com/fastly/d39c18a0122e7743156f4c82492ba4b89df6e7fbe934dbacf209029d566f8195.jpeg",
    "https://cdn.faire.com/fastly/396e95b73f1e375a791aa9493eea370f856a5ef90ccae0af14bd3b661c42f3df.jpeg",
    "https://cdn.faire.com/fastly/acc546135a5d8067273a0f172f1b601d2d9e42607de6f1fb30d45dd550b9ed67.jpeg",
  ],
  priceDollars: 7.95,
  description:
    "Replace paper towels in the kitchen with these ultra absorbent and reusable Swedish dishcloths! Four different 3-packs to choose from.\n\nReusable and Washable: This durable, eco-friendly cleaning cloth can be used again and again. Wash it in your dishwasher or washing machine up to 200x. One dishcloth lasts 9-12 months. This multipack is great for always having a clean cloth on hand. \n\nSUPER Absorbent- This is one super absorbent cloth- it can take in 20 times its own weight in liquid! Just think of all those paper towels you'll no longer be using.\n\nENDLESSLY Versatile- There's almost no limit to where or when you can use this ingenious Scandinavian dishcloth. It's great for cleaning or drying dishes, cleaning up spills, household cleaning, crisper drawers, dusting, and more.\n\nMother Earth Approved: Made of 70% cellulose (wood pulp) from FSC marked forests and 30% cotton from textile waste. 100% compostable at the end of its life.\n\nPackaging: Simple paper sleeve with UPC for retail. \n",
  tags: [],
  msrpDollars: 15.98,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:26.759Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
